import React from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import useResponsive from "../Hooks/responsive";

export default function Privacy() {
  const isMobile = useResponsive()
  return (
    <div className="home-page">
      <Navbar />
      <div className="terms-page">
        <h1 className="cFMxiM">Privacy Notice</h1>

        <div
          itemprop="text"
          font-family="1"
          className="styles__StyledDiv-sc-jb2at6-0 gGDurp"
          style={isMobile ? {width: '90vw', overflowX: 'hidden'}: {}}
        >
          <p>
            <strong>Last updated:</strong> 7 July 2023
          </p>
          <h4>Quick links</h4>
          <p>
            We recommend that you read this Privacy Notice in full to ensure you
            are fully informed. However, if you only want to access a particular
            section of this Privacy Notice, then you can click on the relevant
            link below to jump to that section.
          </p>
          <ul>
            <li>
              <a href="#WhatDoesCelebriLinksDo">What does CelebriLinks do?</a>
            </li>
            <li>
              <a href="#HowDoesThisPrivacyNoticeApplyToMe">
                How does this Privacy Notice apply to me?
              </a>
            </li>
            <li>
              <a href="#WhatPersonalInformationDoWeCollect">
                What personal information do we collect?
              </a>
            </li>
            <li>
              <a href="#WhyDoWeCollectYourPersonalInformation">
                Why do we collect your personal information?
              </a>
            </li>
            <li>
              <a href="#LegalBasisForProcessingPersonalInformation">
                Legal basis for processing personal information
              </a>
            </li>
            <li>
              <a href="#WhoMayWeDiscloseYourPersonalInformationTo">
                Who may we disclose your personal information to?
              </a>
            </li>
            <li>
              <a href="#DisclosureOfPersonalInformationToOtherCountries">
                Disclosure of personal information to other countries
              </a>
            </li>
            <li>
              <a href="#HowDoWeUseCookiesAndSimilarTrackingTechnology">
                How do we use cookies and similar tracking technology?
              </a>
            </li>
            <li>
              <a href="#HowLongDoWeRetainYourPersonalInformation">
                How long do we retain your personal information?
              </a>
            </li>
            <li>
              <a href="#HowDoWeSecureYourPersonalInformation">
                How do we secure your personal information?
              </a>
            </li>
            <li>
              <a href="#WhatAreYourRightsInRelationToPersonalInformation">
                What are your rights in relation to personal information?
              </a>
            </li>
            <li>
              <a href="#Complaints">Complaints</a>
            </li>
            <li>
              <a href="#ChangesToThisPrivacyNotice">
                Changes to This Privacy Notice
              </a>
            </li>
            <li>
              <a href="#ContactUs">Contact us</a>
            </li>
            <li>
              <a href="#SupplementalInformationForCaliforniaResidents">
                Supplemental information for Californian residents
              </a>
            </li>
            <li>
              <a href="#CelebriLinksGroupCompanies">
                CelebriLinks group companies
              </a>
            </li>
            <li>
              <a href="#CelebriLinksServiceProvidersAndPartners">
                CelebriLinks service providers
              </a>
            </li>
          </ul>
          <h4>
            <a id="WhatDoesCelebriLinksDo"></a>What does CelebriLinks do?
          </h4>
          <p>
            CelebriLinks is the launchpad to your latest video, article, recipe,
            tour, store, website, social post, and other content. We connect
            your audience to wherever you are online, and make your content more
            discoverable and easier to manage. Our Website (located at{" "}
            <a href="https://linktr.ee/">https://linktr.ee/)</a> and other
            digital properties (such as our mobile app and Developer Portal)
            (together our “<strong>Platform</strong>”) provides information
            about us and allows individuals and businesses to sign-up as
            CelebriLinks Users (to create a personalised, easily-customisable
            page), as Subscribers (to subscribe to and follow CelebriLinks
            Users), or as developers (to create functionality that interacts
            with our Platform) (together, the “
            <strong>CelebriLinks Services</strong>“).
          </p>
          <p>
            The pages that CelebriLinks Users are able to create using the
            CelebriLinks Services are referred to in this Privacy Notice as “
            <strong>User Profiles</strong>“. User Profiles are accessible by the
            public.
          </p>
          <p>
            We are headquartered in Melbourne, Australia and have offices in
            Sydney. For more information about CelebriLinks, please see the
            “About” section of our Website at&nbsp;
            <a href="https://linktr.ee/s/about/">https://linktr.ee/s/about/</a>.
          </p>
          <h4>
            <a id="HowDoesThisPrivacyNoticeApplyToMe"></a>How does this Privacy
            Notice apply to me?
          </h4>
          <p>
            This Privacy Notice only applies to personal information we collect
            as a controller from:
          </p>
          <ul>
            <li>
              visitors to our Platform (“<strong>Platform Visitors</strong>“);
            </li>
            <li>
              individuals, representatives of individuals, or companies that
              sign up to use our CelebriLinks Services via a paid plan (“
              <strong>Paid Plan Users</strong>“) or free plan (“
              <strong>Free Plan Users</strong>“), together our “
              <strong>CelebriLinks Users</strong>“;
            </li>
            <li>
              individuals that sign up to subscribe to and/or follow User
              Profiles (“<strong>Subscribers</strong>“);
            </li>
            <li>
              individuals that visit and interact with User Profiles (“
              <strong>Profile Visitors</strong>“);
            </li>
            <li>
              developers that sign up to our Developer Portal in order to build
              functionality that interacts with the CelebriLinks Services (“
              <strong>CelebriLinks Developers</strong>”); and
            </li>
            <li>
              individuals who respond to our surveys, marketing materials or
              participate in trade promotions or competitions that we may run
              from time to time.
            </li>
          </ul>
          <p>
            This Privacy Notice, applies to the processing of personal
            information by CelebriLinks as a controller. When we talk about
            CelebriLinks acting as a “controller”, we mean that CelebriLinks
            determines the purpose and the means of the processing (i.e. we make
            decisions about how we will handle your personal information).
            Because of the nature of our services, we can also act as a
            “processor” on behalf of CelebriLinks Users. This means that, when
            we are instructed by a CelebriLinks User, we can facilitate
            processing of Profile Visitors’ and Subscribers’ personal
            information on behalf of that CelebriLinks User (“
            <strong>Processor Services</strong>“). This Privacy Notice does not
            address Processor Services. If you are a Profile Visitor or
            Subscriber, and want to know how a CelebriLinks User handles your
            personal information, please get in touch with the CelebriLinks User
            directly and/or refer to any privacy notice on the relevant User
            Profile.
          </p>
          <p>
            If you provide us with information about another person (if, for
            example, you are a representative of an individual), you must
            provide them with a copy of this Privacy Notice and let that other
            person know that we use their personal information in the ways set
            out in this Privacy Notice.
          </p>
          <h4>
            <a id="WhatPersonalInformationDoWeCollect"></a>What personal
            information do we collect?
          </h4>
          <p>
            The personal information that we may collect about you broadly falls
            into the following categories:
          </p>
          <ul>
            <li>
              <em>
                <span>Information you provide voluntarily</span>
              </em>
              <br />
              When you sign up to become a CelebriLinks User, a Subscriber, use
              or interact with our CelebriLinks Services or staff, visit our
              Platform, visit a User Profile, sign up to our Developer Portal,
              respond to a survey or participate in a trade promotion we may ask
              you to provide personal information voluntarily. For example, if
              you are a Free Plan User we will ask you to provide your email
              address, name, username, hashed password, vertical (industry to
              which your account relates) and marketing preferences. If you are
              a Paid Plan User we will also ask for your full name, billing
              email address, billing address and payment method in order to
              facilitate billing. If you are a Subscriber, we will ask you to
              provide your email address or SMS number.To opt-out of marketing
              communications we send you at any time. You can exercise this
              right by clicking on the “unsubscribe” or “opt-out” link in the
              marketing e-mails or SMS we may send you or completing our Data
              Request Form.You may also provide us with your personal data when
              you submit queries or make a report to us (such as an Intellectual
              Property Report or Counter Notice). For example, we may ask you to
              provide your name and email address so that we can respond to your
              queries. If you are making an Intellectual Property Report or
              Counter Notice, we ask you to provide your name, address, email
              address, phone number and details regarding the intellectual
              property rights concerned.If you are a Profile Visitor, a User
              might request that you provide your email address, mobile number,
              date of birth or age, or other personal information in order to
              access elements of a User Profile (such as locked content). We may
              use the results of such access (i.e. successful or unsuccessful
              access attempts) to produce aggregated statistics for our own
              internal purposes and to improve the CelebriLinks Services.You may
              also provide personal information voluntarily if you respond to
              our surveys, marketing materials, or through your participation in
              trade promotions and competitions we may run from time to time.
            </li>
            <li>
              <em>
                <span>Information that we collect automatically</span>
              </em>
              <br />
              When you visit our Platform, use our CelebriLinks Services,
              interact with a User Profile, respond to a survey or participate
              in a trade promotion we collect certain information automatically
              from your device. In some countries, including countries in the
              European Economic Area and UK, this information may be considered
              personal information under applicable data protection
              laws.Specifically, the information we collect automatically may
              include information like your IP address, device type, unique
              device identification numbers, browser-type, broad geographic
              location (e.g. country or city-level location), time zone, usage
              data, diagnostic data and other technical information. We may also
              collect information about how your device has interacted with our
              Platform, CelebriLinks Service or User Profiles, including the
              pages accessed and links clicked.Collecting this information
              enables us to better understand you, where you come from, and what
              content is of interest to you. We use this information for our
              internal analytics purposes, to improve the quality and relevance
              of our Platform and CelebriLinks Services, to provide hints and
              tips to our CelebriLinks Users and to make recommendations of
              CelebriLinks Profiles you might be interested in viewing.Some of
              this information may be collected using cookies and similar
              tracking technology, as explained further under the heading “
              <a href="#HowDoWeUseCookiesAndSimilarTrackingTechnology">
                How do we use cookies and similar tracking technology
              </a>
              ” below.Further, we may undertake automatic scanning of User
              Profiles and links to determine whether mandatory or default
              sensitive content warnings should be applied and presented to
              Profile Visitors who wish to access the relevant User Profile or
              linked content, and to determine if any content should be removed
              or any User Profiles should be suspended in line with our
              Community Standards and/or Terms of Service. Where a User changes
              their User Profile, we will also notify relevant Subscribers to
              that User Profile that updates have been made.
            </li>
            <li>
              <em>
                <span>Information that we obtain from third party sources</span>
              </em>
              <br />
              From time to time, we may receive personal information about you
              from third party sources (including from service providers that
              help us run marketing campaigns or competitions and our partners
              who help us provide our CelebriLinks Services). In all cases, we
              will only receive such data where we have checked that these third
              parties either have your consent or are otherwise legally
              permitted or required to disclose your personal information to us.
            </li>
            <li>
              <em>
                <span>Children’s data</span>
              </em>
              <br />
              Our services are not intended for use by children under the age of
              18 (the “Age Limit”). If you are under the Age Limit, please do
              not use the CelebriLinks Services and do not provide us with your
              personal information. If you are a parent or guardian and you are
              aware that an individual (of whom you are a parent or guardian)
              under the Age Limit has provided us with personal information,
              please contact us. We will, upon notice or discovery, take all
              reasonable efforts to erase or destroy any personal information
              that may have been collected or stored by us about that
              individual.
            </li>
          </ul>
          <h4>
            <a id="WhyDoWeCollectYourPersonalInformation"></a>Why do we collect
            your personal information?
          </h4>
          <p>
            In general, we will use the information we collect for the purposes
            described in this Privacy Notice or for purposes that we explain to
            you at the time we collect your personal information. These include:
          </p>
          <ul>
            <li>
              To provide and deliver the CelebriLinks Services and to assess,
              maintain and improve the performance and functionality of the
              CelebriLinks Services.
            </li>
            <li>
              To ensure the CelebriLinks Services are relevant to you and your
              device, to notify you about changes to the CelebriLinks Services,
              and to deliver targeted and/or localised content based on your
              user data, location and preferences.
            </li>
            <li>
              For consumer research and to allow you to participate in surveys
              or interactive features of the CelebriLinks Services when you
              choose to do so.
            </li>
            <li>
              To provide customer support and to process and respond to a
              request, complaint or Intellectual Property Report or Counter
              Notice that you may have made.
            </li>
            <li>
              To monitor the usage of the CelebriLinks Services and to detect,
              prevent and address technical issues.
            </li>
            <li>To process payments for Paid Plan Users.</li>
            <li>To conduct business planning, reporting, and forecasting.</li>
            <li>
              To deliver promotional materials, special offers and general
              information about other goods, services and events which we offer
              that are similar to those that you have already purchased or
              enquired about unless you have opted out of receiving such
              information.
            </li>
            <li>
              For the administration of our business including for fulfilling
              and exercising our obligations and rights, exercising or defending
              legal claims, to comply with our legal obligations and law
              enforcement requests, and managing the relationship with you.
            </li>
            <li>
              To verify your identity and to detect fraud and potential fraud,
              including fraudulent payments and fraudulent use of the
              CelebriLinks Services.
            </li>
            <li>
              To include CelebriLinks User content as part of our advertising
              and marketing campaigns to promote CelebriLinks.
            </li>
            <li>
              To inform our algorithms so we can deliver the most relevant
              recommendations to you, including of User Profiles that you may be
              interested in.
            </li>
          </ul>
          <h4>
            <a id="LegalBasisForProcessingPersonalInformation"></a>Legal basis
            for processing personal information
          </h4>
          <p>
            Our legal basis for collecting and using personal information
            described above will depend on the personal information concerned
            and the specific circumstances in which we collect it.
          </p>
          <p>
            However, we will normally collect personal information from you only
            where we have your consent, where we need the personal information
            to perform a contract with you, or where the processing is in our
            legitimate interests and not overridden by your data protection
            interests or fundamental rights and freedoms. In some cases, we may
            also have a legal obligation to collect personal information from
            you, or may otherwise need the personal information to protect your
            vital interests or those of another person.
          </p>
          <p>
            If we ask you to provide personal information to comply with a legal
            requirement we will make this clear at the relevant time and advise
            you whether the provision of your personal information is mandatory
            or not (as well as of the possible consequences if you do not
            provide your personal information). As indicated above, we require
            certain personal information to enter into a contract with you as a
            CelebriLinks User. Without your personal information, we will be
            unable to provide you with CelebriLinks Services available to
            CelebriLinks Users.
          </p>
          <p>
            If we collect and use your personal information in reliance on our
            legitimate interests (or those of any third party), this interest
            will normally be to develop and improve the CelebriLinks Services,
            to provide additional functionality, to ensure appropriate security
            or to implement sensitive content warnings and content moderation.
            We may have other legitimate interests, and if appropriate, we will
            make clear to you at the relevant time what those legitimate
            interests are.
          </p>
          <p>
            If you have questions about or need further information concerning
            the legal basis on which we collect and use your personal
            information, please contact us using the contact details provided
            under the “<a href="#ContactUs">Contact Us</a>” heading below.
          </p>
          <h4>
            <a id="WhoMayWeDiscloseYourPersonalInformationTo"></a>Who may we
            disclose your personal information to?
          </h4>
          <p>
            We may disclose your personal information to the following
            categories of recipients:
          </p>
          <ul>
            <li>
              to our group companies, third party services providers (for
              example, to support the delivery of, provide functionality on, or
              help to enhance the security of our Platform or CelebriLinks
              Services), or who otherwise process personal information for
              purposes that are described in this Privacy Notice or notified to
              you when we collect your personal information. A list of our
              current group companies is available{" "}
              <a href="#CelebriLinksGroupCompanies">here</a> and a list of our
              current service providers and partners is available{" "}
              <a href="#CelebriLinksServiceProvidersAndPartners">here</a>. We
              also facilitate third party payment providers and this is set out
              in more detail below;
            </li>
            <li>
              to the extent we introduce social media log-ins in the future, we
              may provide personal data to the relevant social media provider to
              facilitate such log-in;
            </li>
            <li>
              to any competent law enforcement body, regulatory, government
              agency, court or other third party where we believe disclosure is
              necessary (i) as a matter of applicable law or regulation, (ii) to
              exercise, establish or defend our legal rights, or (iii) to
              protect your vital interests or those of any other person;
            </li>
            <li>
              to an actual or potential buyer (and its agents and advisers) in
              connection with any actual or proposed purchase, merger or
              acquisition of any part of our business, provided that we inform
              the buyer it must use your personal information only for the
              purposes disclosed in this Privacy Notice; and
            </li>
            <li>to any other person with your consent to the disclosure.</li>
          </ul>
          <p>
            In order to facilitate paid products and/or services within the
            CelebriLinks Service, we use third party payment processors. We will
            not store or collect your payment card details. That information is
            provided directly to our third party payment processors whose use of
            your personal information is governed by their privacy policies and
            their own terms and conditions. These payment processors adhere to
            the standards set by payment card industry data security standards
            (“PCI-DSS”) as managed by the Payment Card Industry Security
            Standards Council, which is a joint effort of brands like Visa,
            Mastercard, American Express and Discover. PCI-DSS requirements help
            ensure the secure handling of payment information. The payment
            processors we work with are:
          </p>
          <ul>
            <li>
              Stripe (their privacy policy can be viewed at{" "}
              <a href="https://stripe.com/us/privacy">
                https://stripe.com/us/privacy)
              </a>
              ;
            </li>
            <li>
              PayPal (their privacy policy can be viewed at{" "}
              <a href="https://www.paypal.com/webapps/mpp/ua/privacy-full">
                https://www.paypal.com/webapps/mpp/ua/privacy-full)
              </a>
              ; and
            </li>
            <li>
              Square (their privacy policy can be viewed at{" "}
              <a href="https://squareup.com/au/en/legal/general/privacy">
                https://squareup.com/au/en/legal/general/privacy)
              </a>
              .
            </li>
          </ul>
          <h4>
            <a id="DisclosureOfPersonalInformationToOtherCountries"></a>
            Disclosure of personal information to other countries
          </h4>
          <p>
            Your personal information may be transferred to, and processed in,
            countries other than the country in which you are a resident. These
            countries may have data protection laws that are different to the
            laws of your country (and, in some cases, may not be as protective).
          </p>
          <p>
            Specifically, CelebriLinks may transfer personal information to the
            United States and other countries in which we do business.
            CelebriLinks may also subcontract certain activities and share your
            personal information with third parties located outside of Australia
            (which is where we are headquartered).
          </p>
          <p>
            The countries in which these organisations are located will vary,
            but, in the course of our business operations, we generally disclose
            personal information to organisations located in Australia, or the
            United States. Such transfers are made in order to provide the
            CelebriLinks Services and carry out the activities specified in this
            Privacy Notice.
          </p>
          <p>
            However, we have taken appropriate safeguards to ensure that your
            personal information will remain protected in accordance with this
            Privacy Notice and applicable data protection laws. These include
            entering into data transfer agreements between our group companies
            and these can be provided on request. We have implemented similar
            appropriate safeguards with our third party service providers and
            partners and further details can be provided upon request. No
            transfer of your personal information will take place to an
            organisation or another country unless we believe there to be
            adequate controls in place including the security of your data and
            other personal information. For more details please see the “
            <a href="#HowDoWeSecureYourPersonalInformation">
              How do we secure your personal information
            </a>
            ” section below.
          </p>
          <h4>
            <a id="HowDoWeUseCookiesAndSimilarTrackingTechnology"></a>How do we
            use cookies and similar tracking technology?
          </h4>
          <p>
            We use cookies and similar tracking technology (collectively,
            “Cookies”) to collect and use personal information about you. For
            further information about the types of Cookies we use, why, and how
            you can control Cookies, please see our{" "}
            <a href="https://linktr.ee/s/cookie-notice/" target="_blank">
              Cookie Notice
            </a>
            .
          </p>
          <h4>
            <a id="HowLongDoWeRetainYourPersonalInformation"></a>How long do we
            retain your personal information?
          </h4>
          <p>
            We will retain your personal information for the period necessary to
            fulfil the purposes outlined in this Privacy Notice and in each case
            in accordance with applicable legal and regulatory requirements in
            respect of permitted or required retention periods and limitation
            periods relevant to legal action.
          </p>
          <h4>
            <a id="HowDoWeSecureYourPersonalInformation"></a>How do we secure
            your personal information?
          </h4>
          <p>
            We have put in place appropriate security measures to prevent your
            personal information from being accidentally lost, used or accessed
            in an unauthorised way, altered or disclosed.
          </p>
          <p>
            In addition we limit access to your personal information to
            employees, agents, contractors and other third parties who have a
            business need for access. They will only process your personal
            information on our instructions and they are subject to a duty of
            confidentiality.
          </p>
          <p>
            While we strive to use commercially acceptable means to protect your
            personal information, we cannot guarantee its absolute security.
            Therefore, we have put in place procedures to deal with any
            suspected personal information breach and will notify you and any
            applicable regulator of a breach where we are legally required to do
            so.
          </p>
          <h4>
            <a id="WhatAreYourRightsInRelationToPersonalInformation"></a>What
            are your rights in relation to personal information?
          </h4>
          <p>You have the following data protection rights:</p>
          <ul>
            <li>
              If you wish to&nbsp;access, correct or update&nbsp;your personal
              information, you can do so at any time by completing our{" "}
              <a href="https://linktr.ee/s/gdpr-form/" target="_blank">
                Data Request Form
              </a>
              .
            </li>
          </ul>
          <p>
            Depending on the country which you live in and the laws that apply
            to you, you may also have additional data protection rights. If you
            are resident in the UK or the European Economic Area, these rights
            include:
          </p>
          <ul>
            <li>
              To&nbsp;<strong>request deletion</strong>&nbsp;of your personal
              information. You can do so at any time by completing our{" "}
              <a href="https://linktr.ee/s/gdpr-form/" target="_blank">
                Data Request Form
              </a>
              .
            </li>
            <li>
              To&nbsp;<strong>object to processing</strong>&nbsp;of your
              personal information, ask us to restrict processing of your
              personal information or request portability of your personal
              information. Again, you can exercise these rights by completing
              our{" "}
              <a href="https://linktr.ee/s/gdpr-form/" target="_blank">
                Data Request Form
              </a>
              .
            </li>
            <li>
              To&nbsp;<strong>opt-out of marketing communications</strong>
              &nbsp;we send you at any time. You can exercise this right by
              clicking on the “unsubscribe” or “opt-out” link in the marketing
              e-mails we send you or completing our{" "}
              <a href="https://linktr.ee/s/gdpr-form/" target="_blank">
                Data Request Form
              </a>
              .
            </li>
            <li>
              If we have collected and process your personal information with
              your consent, then you can&nbsp;
              <strong>withdraw your consent</strong>&nbsp;at any time.
              Withdrawing your consent will not affect the lawfulness of any
              processing we conducted prior to your withdrawal, nor will it
              affect processing of your personal information conducted in
              reliance on lawful processing grounds other than consent.
            </li>
            <li>
              The&nbsp;
              <strong>right to complain to a data protection authority</strong>
              &nbsp;about our collection and use of your personal information.
              For more information, please contact your local data protection
              authority. (Contact details for data protection authorities in the
              European Economic Area, Switzerland and certain non-European
              countries (including the US and Canada) are available{" "}
              <a
                href="https://ec.europa.eu/justice/article-29/structure/data-protection-authorities/index_en.htm"
                target="_blank"
              >
                here
              </a>{" "}
              and the UK{" "}
              <a href="https://ico.org.uk/global/contact-us/" target="_blank">
                here
              </a>
              .)
            </li>
          </ul>
          <p>
            We respond to all requests we receive from individuals wishing to
            exercise their data protection rights in accordance with applicable
            data protection laws.
          </p>
          <h4>
            <a id="Complaints"></a>Complaints
          </h4>
          <p>
            We take your privacy concerns seriously. If you have a complaint
            regarding our handling of your personal information or concerning
            our privacy practices, you may file a complaint with us using the
            contact details provided under the “
            <a href="#ContactUs">Contact Us</a>” heading below. We will confirm
            receipt of your complaint and, if we believe necessary, we will open
            an investigation.
          </p>
          <p>
            We may need to contact you to request further details of your
            complaint. If an investigation has been opened following a complaint
            made by you, then we will contact you with the result as soon as
            possible. In the unlikely circumstances we are unable to resolve
            your complaint to your satisfaction, you may contact the local
            privacy and data protection authorities in your jurisdiction.
          </p>
          <h4>
            <a id="ChangesToThisPrivacyNotice"></a>Changes to This Privacy
            Notice
          </h4>
          <p>
            We may update our Privacy Notice from time to time in response to
            changing legal, technical or business developments. When we update
            our Privacy notice, we will take appropriate measures to inform you,
            consistent with the significance of the changes we make. We will
            obtain your consent to any material Privacy Notice changes if and
            where this is required by applicable data protection laws.
          </p>
          <p>
            You can see when this Privacy Notice was last updated by checking
            the “last updated” date displayed at the top of this Privacy Notice.
          </p>
          <h4>
            <a id="ContactUs"></a>Contact Us
          </h4>
          <p>
            If you have any questions about this Privacy Notice, our privacy
            practices or if you would like to make a request about any personal
            information we may hold about you, including correction of personal
            information, please contact us:
          </p>
          <ul>
            <li>By email using: support@linktr.ee</li>
            <li>
              By visiting this page on our Platform:{" "}
              <a href="https://linktr.ee/help/">linktr.ee/help</a>
            </li>
            <li>
              By post at CelebriLinks Pty Ltd, 1-9 Sackville Street, Collingwood
              VIC 3066, Australia.
            </li>
            <li>
              If you want to request any information about how we process, store
              or use your data or anything relating to personal information and
              privacy laws, please use our{" "}
              <a href="https://linktr.ee/s/gdpr-form/" target="_blank">
                Data Request Form
              </a>
              .
            </li>
            <li>
              If you are located in the EU, you may also contact our EU
              representative using the following contact details: Instant EU
              GDPR Representative Ltd, Adam Brogden, contact@gdprlocal.com, Tel
              +353 15 549 700,{" "}
              <a href="https://CelebriLinks.gdprlocal.com/eu">
                https://CelebriLinks.gdprlocal.com/eu
              </a>
              , Instant EU GDPR Representative Ltd 69 Esker Woods Drive, Lucan
              Co. Dublin Ireland
            </li>
            <li>
              If you are located in the United Kingdom, you may also contact our
              UK representative using the following contact details: GDPR Local
              LTD, Adam Brogden, contact@gdprlocal.com, +441 772 217 800,{" "}
              <a href="https://CelebriLinks.gdprlocal.com/uk">
                https://CelebriLinks.gdprlocal.com/uk
              </a>
              , GDPR Local Ltd 1st Floor Front Suite 27-29 North Street,
              Brighton England BN1 1EB
            </li>
          </ul>
          <h4>
            <a id="SupplementalInformationForCaliforniaResidents"></a>
            Supplemental Information for California Residents
          </h4>
          <p>
            The following section provides supplemental information to
            California residents, whose personal information we have collected.
            This section applies to the personal information we collected from
            California residents during the 12 months prior to the effective
            date of this Privacy Notice, depending on interactions with us.
          </p>
          <h5>
            <strong>1. Collection and Use of Personal Information</strong>
          </h5>
          <p>(a) Categories of Personal Information We Have Collected:</p>
          <ul>
            <li>
              <strong>Identifiers</strong> such as name, alias, postal address,
              online identifier (e.g. cookies) and other similar identifiers;
            </li>
            <li>
              <strong>Personal records</strong> such as payment information;
            </li>
            <li>
              <strong>Characteristics</strong> such as age, gender and other
              demographic data;
            </li>
            <li>
              <strong>Customer Accounts / Commercial information</strong> such
              as the User Profile, records of products or services purchased,
              obtained, or considered;
            </li>
            <li>
              <strong>Online usage information</strong> such as Internet and
              other network activity information, such as, but not limited to,
              browsing history, search history and information on interactions
              with the CelebriLinks Services;
              <br />
              <strong>Geolocation data</strong> such as country and zip code;
            </li>
            <li>
              <strong>Sensory information</strong> such as recordings of
              customer service calls; and
            </li>
            <li>
              <strong>Inferences derived from personal information</strong> such
              as purchase preferences, interests and characteristics.There may
              be additional information that we collect that meets the
              definition of personal information under California law but is not
              reflected in a category, in which case we will treat it as
              personal information as required under California law, but will
              not include it when we are required to describe our practices by
              category of personal information.
            </li>
          </ul>
          <p>
            (b) Categories of Sources of Personal Information that We Collect:
          </p>
          <ul>
            <li>
              Directly from you. For example, when you create an account, make a
              purchase, browse our Platform, or use the CelebriLinks Services.
            </li>
            <li>
              Directly and indirectly from activity on the Platform and/or using
              the CelebriLinks Services.
            </li>
            <li>
              Social networks (to the extent we introduce social media log-ins
              in the future).
            </li>
            <li>
              Service Providers who provide services on our behalf such as those
              used to fulfill orders, process your payments and requests, verify
              your information, monitor activity on the Platform and/or using
              the CelebriLinks Services, provide analysis and analytics,
              maintain databases, administer and monitor emails and marketing,
              administer and send mobile messages, serve ads on this and other
              services, and provide consulting services.
            </li>
          </ul>
          <p>&nbsp;</p>
          <h5>2. Categories of Personal Information Disclosed</h5>
          <p>
            We may disclose the following categories of personal information to
            service providers for a business purpose, or, at your direction,
            with third parties such as sponsors of promotions, sweepstakes, or
            contests. We have disclosed the following:
          </p>
          <p>
            <strong>
              Category of Personal Information Disclosed for a Business Purpose
            </strong>
          </p>
          <ul>
            <li>Identifiers;</li>
            <li>Personal records;</li>
            <li>Characteristics;</li>
            <li>Customer Accounts / Commercial information;</li>
            <li>Online usage information;</li>
            <li>Geolocation data;</li>
            <li>Sensory information; and</li>
            <li>Inferences derived from personal information.</li>
          </ul>
          <p>
            <strong>Categories of Recipients</strong>
          </p>
          <ul>
            <li>Service Providers</li>
            <li>Group companies</li>
            <li>Governmental authorities and agencies</li>
          </ul>
          <p>
            We do not sell personal information and we do not believe that our
            sharing of information would qualify as a sale under California law.
          </p>
          <p>
            For the avoidance of doubt, we also do not sell personal information
            of individuals under 16 years of age.
          </p>
          <h5>3. California Privacy Rights</h5>
          <p>
            <strong>(a) Right to Know</strong>
          </p>
          <p>
            You have the right to request that we disclose to you the following
            information about personal information we collect from you:
          </p>
          <ul>
            <li>categories of personal information collected;</li>
            <li>categories of sources of personal information collected;</li>
            <li>
              the business or commercial purpose for collecting or selling
              personal information;
            </li>
            <li>
              the categories of third parties with whom we share personal
              information; and
            </li>
            <li>
              the specific pieces of personal information we have collected
              about you over the past 12 months.
            </li>
          </ul>
          <p>&nbsp;</p>
          <p>
            <strong>
              (b) Right to Request Deletion of Personal Information
            </strong>
          </p>
          <p>
            You have the right to request the deletion of your personal
            information collected or maintained by us, subject to certain
            exceptions permitted by law.
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>
              (c) Right to Opt-Out of Sale of Personal Information
            </strong>
          </p>
          <p>
            As mentioned above, we do not sell personal information and we do
            not believe that our sharing of information would qualify as a sale
            under California law. Nonetheless, if you are a California resident
            who has purchased products or services from us, you may submit a
            request to record your preference to opt out by emailing us at
            support@linktr.ee.
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>(d) Right to Non-Discrimination</strong>
          </p>
          <p>
            You have the right to not be treated in a discriminatory manner for
            exercising your privacy rights. We do not use the fact that you have
            exercised or requested to exercise any privacy rights for any
            purpose other than facilitating a response to your request.
          </p>
          <p>&nbsp;</p>
          <h5>4. Exercising Your California Privacy Rights</h5>
          <p>To exercise your rights, you can contact us:</p>
          <ul>
            <li>By email at support@linktr.ee</li>
            <li>
              By visiting this page on our website:{" "}
              <a href="https://linktr.ee/help/">linktr.ee/help</a>
            </li>
            <li>
              If you want to request any information about how we process, store
              or use your data or anything relating to personal information and
              privacy laws, please use our{" "}
              <a href="https://linktr.ee/s/gdpr-form/" target="_blank">
                Data Request Form
              </a>
              .
            </li>
          </ul>
          <p>
            Once we receive your request, we are required to verify that you are
            the person that is the subject of the request. This verification
            process consists of matching identifying information provided by you
            with the information we have about you in our records. Upon making a
            request, you will be asked to provide your name, email address, and
            request details. A confirmation email will be sent to the email
            address you provide to begin the process to verify your identity. If
            we cannot verify your identity, we will not be able to respond to
            your request.
          </p>
          <p>
            You may designate an authorized agent to exercise any of the above
            privacy rights on your behalf, subject to the agent request
            requirements under California law.
          </p>
          <p>
            Please note, for your safety and security, we will require
            authorized agents to provide proof of consent and designation of the
            authorized agent for the purpose of making the request, and will
            require authorized agents to provide information necessary to verify
            the identity of the individual who is the subject of the request. We
            may also require that an individual verify his/her own identity
            directly with us before we respond to an authorized agent’s request.
          </p>
          <p>
            We reserve the right to deny requests in certain circumstances, such
            as where we have a reasonable belief that the request is fraudulent.
          </p>
          <h5>5. Do Not Track</h5>
          <p>
            California law requires us to let you know how we respond to web
            browser Do Not Track (DNT) signals. Because there currently isn’t an
            industry standard for recognizing or honoring DNT signals, we do not
            respond to them at this time.
          </p>
          <h5>6. California’s Shine the Light law</h5>
          <p>
            We do not share personal information with third parties for their
            direct marketing purposes absent your consent as defined by
            California Civil Code Section 1798.83 (“Shine the Light law”). To
            opt-out of future sharing with third parties for their direct
            marking purposes, contact us at support@linktr.ee. Any such request
            must include “California Privacy Rights Request” in the first line
            of the description and include your name, street address, city,
            state, and ZIP code. Please note that we are only required to
            respond to one request per customer each year.
          </p>
          <h5>7. Changes</h5>
          <p>
            We reserve the right to change this Supplemental Information for
            California Residents from time to time. Changes shall become
            effective on the date they are posted.
          </p>
          <p>&nbsp;</p>
          <h4>
            <a id="CelebriLinksGroupCompanies"></a>CelebriLinks Group Companies
          </h4>
          <p>CelebriLinks International Holdings Pty Ltd</p>
          <p>CelebriLinks, Inc.</p>
          <p>&nbsp;</p>
          <h4>
            <a id="CelebriLinksServiceProvidersAndPartners"></a>CelebriLinks
            Service Providers and Partners
          </h4>
          <ul>
            <li>Amazon Web Services</li>
            <li>Snowflake</li>
            <li>Fivetran</li>
            <li>Intercom</li>
            <li>Prodsight</li>
            <li>Zapier</li>
            <li>ProfitWell</li>
            <li>ChartMogul</li>
            <li>Looker</li>
            <li>Airtable</li>
            <li>SendGrid</li>
            <li>Hubspot</li>
            <li>Typeform</li>
            <li>Great Question</li>
            <li>Formstack</li>
            <li>Fastly</li>
            <li>Square</li>
            <li>ChargeBee</li>
            <li>Stripe</li>
            <li>Braze</li>
            <li>Heap</li>
            <li>AppCues</li>
            <li>Datadog</li>
            <li>Branch</li>
            <li>Google Analytics</li>
            <li>
              Google (via Youtube) – CelebriLinks uses Youtube’s API for Music
              Link or Video link functions to allow you to display Youtube
              videos on your CelebriLinks. This is covered by&nbsp;
              <a
                className="c-link"
                href="https://policies.google.com/privacy?hl=en"
                target="_blank"
              >
                Google’s Privacy Policy
              </a>
            </li>
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
}
